export const COLUMN_NAME = { f_score: 'F-Score', precision: 'Precision', recall: 'Recall', ap: 'AP', d_prime: 'd-prime', accuracy: 'Accuracy', score: 'Score', testset_quantity: 'Testset Quantity' }

export const getComparison = (value1, value2) => {
    if (value1 > value2) return 'text-blue-500';
    if (value1 < value2) return 'text-red-500';
};
